import { ActionTree } from 'vuex';
import { State } from '@/store/modules/cloud/connections/services.store';
import {
  ADD_NEW_CONNECTION,
  CREATE_CONNECTION,
  CURRENT_API_STATUS,
  EDIT_CONNECTION,
  GET_ALL_CONNECTIONS,
  REMOVE_CONNECTION,
  REMOVE_CONNECTION_MUTATION,
  SET_ALL_CONNECTIONS,
  SET_ERROR_MESSAGE,
  UPDATE_EDITED_CONNECTION,
} from '@/store/modules/cloud/connections/services.constants';
import { CloudService } from '@/services/api/integration.service';
import { ErrorWrapper } from '@/services/api/utils';
import { convertDateFormat } from '@/utils/helper-function';

const servicesAction: ActionTree<State, any> = {
  async [GET_ALL_CONNECTIONS]({ commit }) {
    const { data } = await CloudService.getAwsAccounts();
    const configurations = data.configurations?.map((configuration) => {
      return {
        ...configuration,
        updatedAt: convertDateFormat(
          configuration?.updatedAt,
          'DD MMM, YYYY - hh:mm A',
        ),
      };
    });
    if (data.success === true) commit(SET_ALL_CONNECTIONS, configurations);
    else commit(SET_ALL_CONNECTIONS, []);
  },
  async [CREATE_CONNECTION]({ commit }, params) {
    commit(CURRENT_API_STATUS, 'loading');
    try {
      const { data } = await CloudService.createAwsConnection(params);
      if (data.success === true) {
        commit(ADD_NEW_CONNECTION, {
          ...data.data,
          updatedAt: convertDateFormat(
            data.data.createdAt,
            'DD MMM, YYYY - hh:mm A',
          ),
        });
        commit(CURRENT_API_STATUS, 'success');
        setTimeout(() => {
          commit(CURRENT_API_STATUS, 'idle');
        }, 2000);
      } else {
        commit(CURRENT_API_STATUS, 'failed');
        setTimeout(() => {
          commit(CURRENT_API_STATUS, 'idle');
        }, 2000);
      }
    } catch (error) {
      if (error instanceof ErrorWrapper) {
        const parsedError = JSON.parse(JSON.stringify(error));
        if (parsedError.status === 400) {
          commit(CURRENT_API_STATUS, 'idle');
          commit(SET_ERROR_MESSAGE, parsedError.data.message);
        } else {
          commit(CURRENT_API_STATUS, 'failed');
          commit(SET_ERROR_MESSAGE, parsedError.data.message);
        }
      }
    }
  },
  async [EDIT_CONNECTION]({ commit }, params) {
    commit(CURRENT_API_STATUS, 'loading');
    try {
      const { data } = await CloudService.editAwsConnection(params);
      if (data.success === true) {
        commit(UPDATE_EDITED_CONNECTION, {
          ...data.data,
          updatedAt: convertDateFormat(
            data.data.updatedAt,
            'DD MMM, YYYY - hh:mm A',
          ),
        });
        commit(CURRENT_API_STATUS, 'success');
        setTimeout(() => {
          commit(CURRENT_API_STATUS, 'idle');
        }, 2000);
      } else {
        commit(CURRENT_API_STATUS, 'failed');
        setTimeout(() => {
          commit(CURRENT_API_STATUS, 'idle');
        }, 2000);
      }
    } catch (error) {
      if (error instanceof ErrorWrapper) {
        const parsedError = JSON.parse(JSON.stringify(error));
        if (parsedError.status === 400) {
          commit(CURRENT_API_STATUS, 'idle');
          commit(SET_ERROR_MESSAGE, parsedError.data.message);
        } else {
          commit(CURRENT_API_STATUS, 'failed');
          commit(SET_ERROR_MESSAGE, parsedError.data.message);
        }
      }
    }
  },
  async [REMOVE_CONNECTION]({ commit }, subscriptionId) {
    const { data } = await CloudService.deleteAwsAccount(subscriptionId);
    if (data.success === true)
      commit(REMOVE_CONNECTION_MUTATION, subscriptionId);
  },
};

export default servicesAction;
